import algoliasearch from "algoliasearch";

const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID ?? "";
const ALGOLIA_SEARCH_API_KEY =
  process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY ?? "";

export const searchAlgoliaClient = algoliasearch(
  ALGOLIA_APP_ID,
  ALGOLIA_SEARCH_API_KEY,
);


